import { render, staticRenderFns } from "./ConductInspectionItemQuestionAnnotation.vue?vue&type=template&id=4031715c&"
import script from "./ConductInspectionItemQuestionAnnotation.vue?vue&type=script&lang=js&"
export * from "./ConductInspectionItemQuestionAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports